import { render, staticRenderFns } from "./TroubleTicket.vue?vue&type=template&id=4ba41f47&scoped=true"
import script from "./TroubleTicket.vue?vue&type=script&lang=js"
export * from "./TroubleTicket.vue?vue&type=script&lang=js"
import style0 from "./TroubleTicket.vue?vue&type=style&index=0&id=4ba41f47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba41f47",
  null
  
)

export default component.exports